module.exports = __webpack_public_path__ + "img/hr-brown-fluff-01.6f241980.png";